import { prismicSliceToAccordion } from 'prismic/slices/Accordion/AccordionSlice';
import { prismicSliceToCallToAction } from 'prismic/slices/CallToAction/CallToActionSlice';
import { prismicSliceToCountDown } from 'prismic/slices/CountDown/CountDownSlice';
import { prismicSliceToGoogleSheetTableSlice } from 'prismic/slices/GoogleSheetTable/GoogleSheetTableSlice';
import { prismicSliceToNumbers } from 'prismic/slices/Numbers/NumbersSlice';
import { prismicSliceToPrices } from 'prismic/slices/Prices/PricesSlice';
import { prismicSliceToQuote } from 'prismic/slices/Quote/QuoteSlice';
import { prismicSliceToStaffList } from 'prismic/slices/StaffList/StaffListSlice';
import { prismicSliceToText } from 'prismic/slices/Text/TextSlice';
import { prismicSliceToVideo } from 'prismic/slices/Video/VideoSlice';
import {
  EducationSlices,
  EducationSlicesAccordion,
  EducationSlicesCall_To_Action,
  EducationSlicesCount_Down,
  EducationSlicesGoogle_Sheet_Table,
  EducationSlicesNumbers,
  EducationSlicesPrices,
  EducationSlicesQuote,
  EducationSlicesStaff_List,
  EducationSlicesText,
  EducationSlicesVideo,
} from 'prismic-types';

import { ArticleSection } from 'components/article-section/ArticleSection';
import { Section } from 'components/section/Section';

type Props = {
  slices?: Array<EducationSlices>;
  date?: string;
};

export function EducationSlices({ slices = [], date }: Props) {
  return (
    <>
      {slices.map((s: EducationSlices, i: number) => {
        const key = `slice-${s.type}-${i}`;

        switch (s.type) {
          case 'quote':
            return (
              <ArticleSection key={key}>
                {prismicSliceToQuote(s as EducationSlicesQuote)}
              </ArticleSection>
            );
          case 'call_to_action':
            return (
              <Section key={key}>
                {prismicSliceToCallToAction(
                  s as EducationSlicesCall_To_Action,
                  i === 0 ? date : undefined
                )}
              </Section>
            );
          case 'numbers':
            return (
              <Section key={key}>
                {prismicSliceToNumbers(s as EducationSlicesNumbers)}
              </Section>
            );
          case 'google_sheet_table':
            return (
              <ArticleSection key={key}>
                {prismicSliceToGoogleSheetTableSlice(
                  s as EducationSlicesGoogle_Sheet_Table
                )}
              </ArticleSection>
            );
          case 'accordion':
            return (
              <ArticleSection key={key}>
                {prismicSliceToAccordion(s as EducationSlicesAccordion)}
              </ArticleSection>
            );
          case 'prices':
            return (
              <Section key={key}>
                {prismicSliceToPrices(s as EducationSlicesPrices)}
              </Section>
            );
          case 'count_down':
            return (
              <Section key={key} container>
                {prismicSliceToCountDown(s as EducationSlicesCount_Down)}
              </Section>
            );
          case 'staff_list':
            return (
              <Section key={key}>
                {prismicSliceToStaffList(s as EducationSlicesStaff_List)}
              </Section>
            );
          case 'text':
            return (
              <ArticleSection key={key}>
                {prismicSliceToText(
                  s as EducationSlicesText,
                  undefined,
                  i === 0 ? date : undefined
                )}
              </ArticleSection>
            );
          case 'video':
            return (
              <ArticleSection key={key}>
                {prismicSliceToVideo(s as EducationSlicesVideo)}
              </ArticleSection>
            );
          default:
            console.info(`EducationSlices: unknown slice type ${s.type}`, s);
            return process.env.NODE_ENV === 'production' ? null : (
              <Section key={key}>{`unknown slice type ${s.type}`}</Section>
            );
        }
      })}
    </>
  );
}
